module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_budzets_mobile-f427ecb2a3f83f13078c959eb8b0665e.webp";